module.exports = __webpack_public_path__ + "static/media/MD-De-Rantau.0b016029.png";